import * as React from "react";
import { nextWeekDay } from "../../../../../utils";
import moment from "moment-timezone";
import { useCallback, useEffect, useState } from "react";
import { DateTimePicker } from "../../../../DateTimePicker";

interface ProjectSchedulerParams {
  deliveryDate?: string;
  minDate?: Date;
  editable?: boolean;
  onChange: (d: Date) => void;
}

type Props = ProjectSchedulerParams;

export const ProjectScheduler: React.FC<Props> = ({
  deliveryDate,
  editable = true,
  minDate = nextWeekDay(2),
  onChange,
}) => {
  const [postDate, setPostDate] = useState<Date | undefined>();

  useEffect(() => {
    if (deliveryDate) {
      setPostDate(moment(deliveryDate).toDate());
    } else {
      setPostDate(minDate);
    }
  }, [deliveryDate]);

  const updateDate = useCallback(
    (date: Date | undefined) => {
      setPostDate(date);
      if (date) onChange(date);
    },
    [onChange]
  );

  return (
    <DateTimePicker
      selectedDate={postDate}
      selectedTime={postDate}
      onChangeDate={updateDate}
      onChangeTime={updateDate}
      editable={editable}
    />
  );
};
